import { ConfigLoader } from '@ztsi/ztools';

//应用程序配置
let config;
try {
  config = ConfigLoader.readAndConvertSync('./config/module.xml');
} catch (e) {}

export default config;



// WEBPACK FOOTER //
// ./src/config/module/index.js